import { useFetch } from "../../utils/hooks";
import { listTopGamess } from "../../graphql/queries";
import CompetitionGameList from "../../components/competition-game-list";
import PageLinks from "../../components/page-links";
import { getCacheExpiryForGames } from "../../utils/queryDatabase";
import { useEffect, useState } from "preact/hooks";
import { InfoIcon } from "../../components/icons/initial";
import { route } from "preact-router";

const Home = () => {
  const [trigger, setTrigger] = useState(Date.now());
  const [response, isLoading] = useFetch(
    listTopGamess,
    "listTopGamess",
    { limit: 500 },
    getCacheExpiryForGames,
    trigger,
    true
  );

  useEffect(() => {
    let timer = setInterval(() => setTrigger(Date.now()), 3 * 60 * 1000);
    return () => clearInterval(timer);
  }, []);

  const games = response?.games?.items ? response?.games?.items : response;
  return (
    <div>
      <div class={"info_container"} onClick={() => route(`/info`)}>
        <InfoIcon />
      </div>
      <PageLinks />
      <CompetitionGameList games={games} isLoading={isLoading} gamesNum={6} />
    </div>
  );
};
//
export default Home;
